import { Avatar, Badge, Typography } from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'

export const SelectableUserAvatar = ({
	selected = false,
	userId,
	name,
	photoSrc,
	updateToggled,
}) => {
	return (
		<div
			key={userId}
			style={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center',
			}}
		>
			{selected ? (
				<>
					<Badge
						overlap={'circular'}
						anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
						badgeContent={
							<div
								style={{
									backgroundColor: 'white', // mask background
									borderRadius: '50%',
									padding: 1, // adjust as needed
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
								}}
							>
								<CheckCircleIcon sx={{ color: '#4CAF50' }} />
							</div>
						}
					>
						<div>
							<Avatar
								onClick={() => updateToggled(userId)}
								sx={{
									width: 96,
									height: 96,
									border: '4px  solid #4CAF50',
									cursor: 'pointer',

									'@media (max-width: 767px)': {
										width: 64,
										height: 64,
									},
								}}
								alt={name}
								src={photoSrc}
							/>
							<Typography
								style={{
									textAlign: 'center',
									fontFamily: 'Bodoni 72',
									fontSize: '14px',
									fontWeight: '600',
									color: '#313131',
									marginTop: '8px',
									textTransform: 'capitalize',
								}}
							>
								{name}
							</Typography>
						</div>
					</Badge>
				</>
			) : (
				<>
					<Avatar
						onClick={() => updateToggled(userId)}
						sx={{
							width: 96,
							height: 96,
							border: '4px  solid transparent',
							cursor: 'pointer',

							'@media (max-width: 767px)': {
								width: 64,
								height: 64,
							},
						}}
						alt={name}
						src={photoSrc}
					/>
					<Typography
						style={{
							textAlign: 'center',
							fontFamily: 'Inter',
							fontSize: '14px',
							fontWeight: '600',
							color: '#313131',
							marginTop: '8px',
							textTransform: 'capitalize',
						}}
						key={userId}
					>
						{name}
					</Typography>
				</>
			)}
		</div>
	)
}
